import { Edit } from '@mui/icons-material'
import { Box, Button, IconButton, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import useAlert from '../../hooks/useAlert'
import { authedAxios } from '../../utils'
import {
  mergeUpdateObjectAtIndex,
  updateObjectWithMatchingId,
} from '../../utils/array'
import ActivityIcons from './activityIcons'

const Goals = ({ goals, activityTypes, identities, selectedIdentites }) => {
  const identity = selectedIdentites[0]

  const title = identity ? `${identity.firstName}'s goals` : 'Default goals'
  const [goalsCopy, setGoalsCopy] = useState(goals)
  const [editing, setEditing] = useState(false)

  const { createAlert, createGenericErrorAlert } = useAlert()

  useEffect(() => {
    setGoalsCopy(goals)
  }, [goals])

  const save = () => {
    return authedAxios
      .put(`/api/activity/goals/${identity?.id || 'default'}`, goalsCopy)
      .then(() => {
        createAlert({ message: 'Successfuly saved goals' })
        setEditing(false)
      })
      .catch(() => {
        createGenericErrorAlert()
      })
  }

  const editGoalValue = (activityTypeId, value) => {
    const match = goalsCopy.find((g) => g.activityTypeId === activityTypeId)
    const index = goalsCopy.indexOf(match)

    setGoalsCopy(
      mergeUpdateObjectAtIndex(
        goalsCopy,
        { activityTypeId, goal: value },
        index
      )
    )
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Typography variant='h6' sx={{ mr: 2 }}>
          {title}
        </Typography>
        {!editing && (
          <IconButton onClick={() => setEditing(true)}>
            <Edit />
          </IconButton>
        )}
      </Box>

      {activityTypes.map((at) => {
        const goal = goalsCopy.find((g) => g.activityTypeId === at.id)

        const Icon = ActivityIcons[at.id]

        return (
          <Box
            key={at.id}
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 1,
            }}
          >
            <Box sx={{ width: '300px', display: 'flex', alignItems: 'center' }}>
              {!!Icon && <Icon color={'primary'} sx={{ mr: 1 }} />}
              {at.name}
            </Box>
            <Box
              sx={{
                display: 'flex',
                width: '200px',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              <Typography sx={{ mr: 2 }}>Monthly Total:</Typography>
              <TextField
                type={'number'}
                value={goal?.goal || ''}
                disabled={!editing}
                onChange={(e) => {
                  editGoalValue(at.id, e.target.value)
                }}
              ></TextField>
            </Box>
          </Box>
        )
      })}
      {editing && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            sx={{ mr: 1 }}
            variant={'outlined'}
            onClick={() => {
              setGoalsCopy(goals)
              setEditing(false)
            }}
          >
            Cancel
          </Button>
          <Button variant={'contained'} onClick={save}>
            Save
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default Goals
